import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../../Context";
import { useContext } from "react";
import { HOME } from "../../routes";

const PublicLayout = () => {
  const { user } = useContext(UserContext);
  const isLoggedIn = Boolean(user);

  if (isLoggedIn) {
    return <Navigate to={HOME} />;
  }

  return (
    <main className="bg-slate-100 h-full">
      <Outlet />
    </main>
  );
};

export default PublicLayout;